import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ProductConfigService } from '@backoffice-monorepo/commons';

@Injectable({
  providedIn: 'root'
})
export class ProductSubTypesResolver {

  constructor(
    private productConfigService: ProductConfigService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<string[]> {
    return this.productConfigService.listProductSubTypes();
  }
}
